const es = {
  // Nav
  "nav.dashboard": "Inicio",
  "nav.certificates": "Mis certificados",
  "nav.request": "Solicitar nuevo",
  "nav.documents": "Documentos",
  "nav.profile": "Mi perfil",
  "nav.help": "Ayuda",
  "nav.portal": "Mi PahCertificar",

  // Common
  "common.loading": "Cargando…",
  "common.continue": "Continuar",
  "common.back": "Atrás",
  "common.next": "Siguiente",
  "common.submit": "Enviar",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.edit": "Editar",
  "common.download": "Descargar",
  "common.view": "Ver",
  "common.close": "Cerrar",
  "common.search": "Buscar",
  "common.logout": "Salir",
  "common.required": "Obligatorio",
  "common.optional": "Opcional",
  "common.today": "Hoy",
  "common.days": "días",
  "common.yes": "Sí",
  "common.no": "No",

  // Status
  "status.active": "Activo",
  "status.expiring": "Por vencer",
  "status.expired": "Vencido",
  "status.pending": "En proceso",
  "status.verified": "Verificado",
  "status.rejected": "Rechazado",
  "status.revoked": "Revocado",
  "status.issued": "Emitido",
  "status.draft": "Borrador",
  "status.uploaded": "Subido",
  "status.missing": "Falta",

  // Dashboard
  "dash.greeting_morning": "Buenos días",
  "dash.greeting_afternoon": "Buenas tardes",
  "dash.greeting_evening": "Buenas noches",
  "dash.welcome_subtitle": "Esto es lo que está pasando con tus certificados hoy.",
  "dash.stat_active": "Certificados activos",
  "dash.stat_expiring": "Por vencer (90 días)",
  "dash.stat_in_progress": "En proceso",
  "dash.stat_documents": "Documentos subidos",
  "dash.your_certs": "Tus certificados",
  "dash.view_all": "Ver todos",
  "dash.quick_actions": "Acciones rápidas",
  "dash.qa_new_cert": "Solicitar un certificado",
  "dash.qa_new_cert_desc": "Empieza una nueva solicitud en 3 pasos",
  "dash.qa_upload": "Subir un documento",
  "dash.qa_upload_desc": "Guarda tus documentos para futuras solicitudes",
  "dash.qa_renew": "Renovar certificado",
  "dash.qa_renew_desc": "Renueva antes de que venza, sin empezar de cero",
  "dash.recent_activity": "Actividad reciente",
  "dash.no_activity": "Cuando pase algo con tu certificado, lo verás aquí.",
  "dash.empty_title": "Aún no tienes certificados",
  "dash.empty_body": "Empieza tu primera solicitud. Te guiamos paso a paso.",
  "dash.start_first": "Empezar mi primer certificado",
  "dash.expiring_banner": "Tienes {count} certificado(s) por vencer pronto",
  "dash.expiring_cta": "Renovar ahora",

  // Certificates
  "cert.title": "Mis certificados",
  "cert.subtitle": "Todos los certificados emitidos, en proceso y vencidos.",
  "cert.filter_all": "Todos",
  "cert.filter_active": "Activos",
  "cert.filter_pending": "En proceso",
  "cert.filter_expired": "Vencidos",
  "cert.empty_filter": "No tienes certificados en este estado.",
  "cert.holder": "Titular",
  "cert.serial": "Número de serie",
  "cert.issued_on": "Emitido",
  "cert.expires_on": "Vence",
  "cert.issuer": "Entidad emisora",
  "cert.days_remaining": "{days} días restantes",
  "cert.expired_ago": "Venció hace {days} días",
  "cert.download_pfx": "Descargar PFX",
  "cert.download_cer": "Descargar .cer",
  "cert.renew": "Renovar",
  "cert.revoke": "Revocar",
  "cert.timeline_title": "Historial",
  "cert.docs_title": "Documentos asociados",
  "cert.details_title": "Detalles técnicos",
  "cert.spec_algo": "Algoritmo",
  "cert.spec_key": "Tamaño de llave",
  "cert.spec_validity": "Vigencia",
  "cert.spec_format": "Formato",
  "cert.back_to_list": "Volver a mis certificados",
  "cert.requests_title": "Solicitudes",
  "cert.requests_subtitle": "Estado de tus solicitudes y archivos publicados por nuestro equipo.",
  "cert.no_requests": "No hay solicitudes activas",
  "cert.no_requests_body": "Cuando nuestro equipo cree o actualice una solicitud, aparecerá aquí.",
  "cert.open_request": "Ver solicitud",
  "cert.request_detail_title": "Detalle de solicitud",
  "cert.request_not_found": "Solicitud no encontrada",
  "cert.request_status": "Estado",
  "cert.request_created_on": "Creada",
  "cert.request_updated_on": "Actualizada",
  "cert.request_artifacts": "Archivos disponibles",
  "cert.no_public_artifacts": "Aún no hay archivos publicados para esta solicitud.",
  "cert.class": "Clase",
  "cert.validity": "Vigencia",
  "cert.download_artifact": "Descargar archivo",
  "artifact.rut": "RUT",
  "artifact.camara_comercio": "Cámara de comercio",
  "artifact.cedula": "Documento de identidad",
  "artifact.poder": "Poder",
  "artifact.formulario": "Formulario",
  "artifact.attachment": "Anexo",
  "artifact.response_document": "Documento de respuesta",

  // Certificate types
  "type.factura_electronica": "Facturación electrónica",
  "type.firma_digital": "Firma digital",
  "type.ssl": "SSL",
  "type.autenticacion": "Autenticación",
  "type.firma_natural": "Firma Digital Persona Natural",
  "type.firma_natural_desc": "Firma digital con token virtual para una persona natural.",
  "type.firma_natural_rut": "Firma Digital Persona Natural con RUT",
  "type.firma_natural_rut_desc": "Firma digital con token virtual para una persona natural inscrita en el RUT.",
  "type.firma_representante": "Firma Digital Representante Legal",
  "type.firma_representante_desc": "Firma digital con token virtual asociada al rol de representante legal.",
  "type.firma_juridica": "Firma Digital Pertenencia a Empresa",
  "type.firma_juridica_desc": "Firma digital con token virtual asociada a la vinculación con una empresa.",
  "type.profesional": "Firma Digital Profesional Titulado",
  "type.profesional_desc": "Firma digital con token virtual asociada a una profesión acreditada.",
  "type.funcion_publica": "Firma Digital Función Pública",
  "type.funcion_publica_desc": "Firma digital con token virtual asociada a un cargo en una entidad pública.",
  "type.funcion_publica_siif": "Firma Digital Función Pública SIIF Nación",
  "type.funcion_publica_siif_desc": "Firma digital con token virtual para titulares que operan con SIIF Nación.",
  "type.comunidad_academica": "Firma Digital Comunidad Académica",
  "type.comunidad_academica_desc": "Firma digital con token virtual asociada a una institución académica.",
  "type.facturacion": "Facturación Electrónica DIAN",
  "type.facturacion_desc": "Solicitud disponible en línea con vigencia de un año.",

  // Request wizard
  "req.title": "Nueva solicitud",
  "req.progress": "Paso {current} de {total}",
  "req.step1": "Tipo",
  "req.step2": "Datos",
  "req.step3": "Documentos",
  "req.step4": "Repaso",
  "req.step1_title": "¿Qué tipo de certificado necesitas?",
  "req.step1_subtitle": "Facturación electrónica aparece primero. Después puedes elegir entre ocho firmas digitales con token virtual, todas iniciadas desde PahCertificar.",
  "req.token_catalog_title": "Después, firmas digitales con token virtual",
  "req.token_catalog_subtitle": "Elige el uso que corresponde a tu identidad o función.",
  "req.available_online": "Disponible en línea",
  "req.token_available": "Compra acompañada",
  "req.token_note": "Elige la vigencia. PahCertificar te acompaña durante la compra y el seguimiento, y custodia de forma segura los archivos que se incorporen a tu cuenta. Al continuar, completarás el pago y los soportes en el canal seguro presentado por la plataforma.",
  "req.token_cta": "Continuar con la compra",
  "req.token_footer_hint": "Para una firma con token, elige la vigencia y usa “Continuar con la compra” en la tarjeta seleccionada.",
  "req.step2_title": "Cuéntanos de ti",
  "req.step2_subtitle": "Solo lo imprescindible. Tus datos quedan cifrados.",
  "req.step3_title": "Sube tus documentos",
  "req.step3_subtitle": "Arrastra o selecciona los archivos. Aceptamos PDF y JPG hasta 10 MB.",
  "req.step4_title": "Repasemos",
  "req.step4_subtitle": "Revisa que todo esté bien antes de enviar.",
  "req.doc_cedula": "Cédula de ciudadanía",
  "req.doc_cedula_hint": "Frente y reverso escaneados o foto nítida.",
  "req.doc_rut": "RUT actualizado",
  "req.doc_rut_hint": "No mayor a 30 días.",
  "req.doc_camara": "Cámara de Comercio",
  "req.doc_camara_hint": "No mayor a 30 días. Solo para personas jurídicas.",
  "req.field_name": "Nombre completo",
  "name.first": "Primer nombre",
  "name.second": "Segundo nombre",
  "name.first_surname": "Primer apellido",
  "name.second_surname": "Segundo apellido",
  "name.dian_hint": "Nombre en DIAN:",
  "name.company": "Razón social",
  "req.field_doc_type": "Tipo de documento",
  "req.field_doc_number": "Número de documento",
  "req.field_email": "Correo electrónico",
  "req.field_phone": "Teléfono",
  "req.field_city": "Ciudad",
  "req.field_department": "Departamento",
  "req.select_department": "Selecciona un departamento",
  "req.select_city": "Selecciona una ciudad",
  "req.select_city_first": "Elige primero un departamento",
  "req.field_address": "Dirección",
  "req.field_validity": "Vigencia del certificado",
  "req.validity_1": "1 año",
  "req.validity_2": "2 años",
  "req.validity_3": "3 años",
  "req.validity_m3": "3 meses",
  "req.validity_m6": "6 meses",
  "req.validity_single_option": "La vigencia disponible para esta solicitud es {label}.",
  "req.price_from": "Desde {price}",
  "req.submit": "Enviar solicitud",
  "req.success_title": "¡Listo! Recibimos tu solicitud",
  "req.success_body": "Te escribiremos a {email} en menos de 24 horas con los siguientes pasos.",
  "req.success_ref": "Referencia",
  "req.success_go_dashboard": "Ir al inicio",

  // Documents
  "docs.title": "Mis documentos",
  "docs.subtitle": "Guarda tus documentos para reutilizarlos en futuras solicitudes.",
  "docs.upload": "Subir documento",
  "docs.drop_title": "Arrastra tu archivo aquí",
  "docs.drop_subtitle": "o haz clic para buscarlo en tu equipo",
  "docs.drop_formats": "PDF, JPG o PNG · máximo 10 MB",
  "docs.empty_title": "No hay documentos todavía",
  "docs.empty_body": "Sube los documentos que usas con frecuencia y los tendrás a la mano para tu próxima solicitud.",
  "docs.type_cedula": "Cédula",
  "docs.type_rut": "RUT",
  "docs.type_camara_comercio": "Cámara de Comercio",
  "docs.type_poder": "Poder",
  "docs.type_otro": "Otro",
  "docs.uploaded_on": "Subido",
  "docs.size": "Tamaño",

  // Profile
  "profile.title": "Mi perfil",
  "profile.subtitle": "Tus datos personales y de contacto.",
  "profile.personal": "Datos personales",
  "profile.contact": "Contacto",
  "profile.notifications": "Notificaciones",
  "profile.language": "Idioma",
  "profile.danger": "Zona peligrosa",
  "profile.delete": "Eliminar cuenta",
  "profile.notif_email": "Recibir correos sobre el estado de mis certificados",
  "profile.notif_expiry": "Avisarme 30 días antes de un vencimiento",
  "profile.notif_marketing": "Novedades y consejos de PahCertificar",

  // Help
  "help.title": "Ayuda",
  "help.subtitle": "Respuestas rápidas y formas de contactarnos.",
  "help.search_placeholder": "Busca una pregunta…",
  "help.contact_title": "¿Prefieres hablar con alguien?",
  "help.contact_body": "Nuestro equipo responde en menos de un día hábil.",
  "help.contact_email": "Escribir correo",
  "help.contact_whatsapp": "Abrir WhatsApp",

  // Chat / floating
  "chat.need_help": "¿Necesitas ayuda?",
  "chat.hint": "Pregúntanos cualquier cosa",

  // Auth
  "auth.secure_signin": "Inicio de sesión seguro",
  "auth.login_title": "Bienvenido a tu portal de certificados",
  "auth.login_subtitle":
    "Ingresa con tu número de WhatsApp. Sin contraseñas: te enviamos un código por WhatsApp y entras en segundos.",
  "auth.signin_cta": "Continuar con WhatsApp",
  "auth.feature_whatsapp": "Te enviamos un código de 6 dígitos por WhatsApp",
  "auth.feature_no_password": "Sin contraseñas: tu número es tu identidad",
  "auth.legal_prefix": "Al continuar aceptas la",
  "auth.legal_privacy": "política de privacidad",
  "auth.legal_and": "y los",
  "auth.legal_terms": "términos",
  "auth.callback_working_title": "Verificando tu sesión",
  "auth.callback_working_body":
    "Estamos confirmando tu código y entrando a tu portal. Esto solo toma unos segundos.",
  "auth.callback_error_title": "No pudimos iniciar tu sesión",
  "auth.callback_error_body":
    "El código expiró o el enlace ya no es válido. Vuelve a iniciar sesión y te enviamos otro.",
  "auth.phone_label": "Número de WhatsApp",
  "auth.role_admin": "Admin",
  "auth.role_user": "Cliente",

  // Onboarding (email + document verification)
  "onb.step_doc": "Tu documento",
  "onb.step_code": "Código por email",
  "onb.secure_step": "Paso seguro · 1 de 2",
  "onb.doc_title": "Verifiquemos tu identidad",
  "onb.doc_subtitle":
    "Necesitamos tu tipo y número de documento para confirmar quién eres y traer tu correo registrado en DIAN.",
  "onb.phone_verified": "Tu WhatsApp ya quedó verificado",
  "onb.doc_type": "Tipo de documento",
  "onb.doc_number": "Número de documento",
  "onb.doc_helper":
    "Buscamos tu información en la DIAN. No guardamos nada hasta que confirmes el código que llega a tu correo.",
  "onb.continue": "Buscar y enviar código",
  "onb.privacy_note":
    "Al continuar, autorizas que consultemos tu nombre y correo en la DIAN para verificar tu identidad.",
  "onb.email_sent": "Te enviamos un código a tu correo",
  "onb.email_sent_chip": "Email enviado · 6 dígitos",
  "onb.email_resent": "Reenviamos el código",
  "onb.greeting": "Hola, {name} 👋",
  "onb.code_subtitle":
    "Te enviamos un código de 6 dígitos a",
  "onb.code_label": "Código del email",
  "onb.verify": "Verificar y entrar",
  "onb.resend": "Reenviar código",
  "onb.change_doc": "¿Cambiaste de documento?",
  "onb.welcome": "¡Listo! Bienvenido",
  "onb.unlocking": "Cargando tu portal…",
  "onb.err_doc_required": "Ingresa tu número de documento.",
  "onb.err_not_found":
    "No encontramos este documento en la DIAN. Verifica el tipo y número, o escríbenos.",
  "onb.err_code_format": "El código debe tener 6 dígitos.",
  "onb.err_unknown": "Algo salió mal. Intenta otra vez.",

  // Pricing + payment (Request wizard + return page)
  "req.price_title": "Costo del certificado",
  "req.price_subtitle": "Pago único, IVA incluido. Te llega la factura por correo.",
  "req.price_includes_dian": "Flujo para facturación electrónica",
  "req.price_includes_issuer": "Una entidad de certificación digital acreditada evalúa y, si aprueba, emite",
  "req.price_includes_support": "Soporte humano por WhatsApp",
  "req.approval_conditional": "El pago inicia la revisión, pero no garantiza aprobación, emisión ni un plazo fijo. La entidad de certificación puede pedir información adicional o rechazar la solicitud conforme a sus políticas.",
  "req.price_secure_checkout": "Pago seguro con Nequi",
  "req.total": "Total",
  "req.pay_and_submit": "Pagar y enviar solicitud",
  "pay.checking_title": "Confirmando tu pago",
  "pay.checking_body": "Estamos verificando con Nequi. Esto solo toma unos segundos.",
  "pay.success_title": "¡Pago recibido!",
  "pay.success_body": "Tu solicitud está en revisión. Te avisaremos por WhatsApp cuando haya una actualización.",
  "pay.go_home": "Ir al inicio",
  "pay.cancelled_title": "Cancelaste el pago",
  "pay.cancelled_body": "No te preocupes, no te cobramos nada. Puedes volver a intentar cuando quieras.",
  "pay.failed_title": "No pudimos confirmar tu pago",
  "pay.failed_body": "El proveedor reportó un error o el cobro caducó. Vuelve a intentar la solicitud.",
  "pay.taking_too_long": "Esto está tardando más de lo normal. Si ya pagaste, te avisamos por WhatsApp en cuanto lo confirmemos.",
  "pay.retry": "Volver a intentar",
  "pay.push_title": "Revisa tu Nequi 📱",
  "pay.push_body":
    "Pago únicamente con Nequi. Te enviamos una notificación a tu app — tienes 3 minutos para aprobarla.",
  "pay.push_step1": "Abre la app de Nequi en este número",
  "pay.push_step2": "Toca la notificación de pago de PAH VENTURE SAS",
  "pay.push_step3": "Confirma {amount} con tu PIN de Nequi",
  "pay.push_step3_generic": "Confirma el pago con tu PIN de Nequi",
  "pay.push_listening": "Esperando tu aprobación…",

  // Nequi-phone confirmation dialog (before pushing the cobro)
  "nequi.dialog_title": "Confirma tu Nequi",
  "nequi.dialog_subtitle":
    "Pago únicamente con Nequi. Vamos a enviarte un cobro de {amount} a tu app de Nequi para que lo apruebes desde tu celular.",
  "nequi.phone_label": "Número con Nequi",
  "nequi.phone_helper":
    "Si tu Nequi está en otro celular, escribe ese número aquí. No te cobramos hasta que apruebes en la app.",
  "nequi.confirm": "Enviar cobro a mi Nequi",
  "nequi.dialog_disclaimer":
    "Pago seguro. La aprobación final ocurre dentro de tu app de Nequi.",
  "nequi.err_not_found":
    "Este número no tiene Nequi. Verifica que lo escribiste bien o intenta con otro celular.",
};

export default es;
export type Dict = typeof es;
